module.exports = __webpack_public_path__ + "media/images/profile/cover-4eac33e1b6a9168b622749cd80c09df3.jpg";